import React, { useState } from "react";
import emailjs from "emailjs-com";
import Avatar from "../assets/avatar.jpg";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID as string | undefined;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID as string | undefined;
    const userId = process.env.REACT_APP_EMAILJS_USER_ID as string | undefined;
    if (!serviceId || !templateId || !userId) {
      throw new Error("EmailJS environment variables are not set.");
    }

    emailjs.sendForm(serviceId, templateId, e.target as HTMLFormElement, userId);

    setSent(true);
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <section id="contact" className="py-20 px-4 bg-gray-950">
      <div className="max-w-[900px] mx-auto">
        {/* About Me Section */}
        <div className="flex flex-col md:flex-row items-center gap-10 mb-16">
          <div className="flex-1">
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#00df9a] mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Let’s Connect!
            </h2>
            <p className="text-gray-600 text-lg">
              I’m Marcin, a Senior Software Engineer passionate about building digital products that make a difference. Whether you have a project in mind, want to collaborate, or just want to say hi—drop me a message!
            </p>
          </div>
          <div className="flex-1 flex justify-center">
            <img
              src={Avatar}
              alt="Marcin"
              className="w-48 h-48 object-cover rounded-full border-4 border-[#00df9a] shadow-lg"
            />
          </div>
        </div>
        {/* Contact Form Section */}
        <div className="bg-gray-100 rounded-xl shadow-lg p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">Contact Form</h3>
          {sent ? (
            <div className="text-green-600 font-semibold text-lg">
              Thank you for your message! I’ll get back to you soon.
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="flex flex-col gap-6">
              <div className="flex flex-col md:flex-row gap-6">
                <div className="flex-1 flex flex-col">
                  <label htmlFor="name" className="mb-1 font-semibold text-gray-700">
                    Name
                  </label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    required
                    className="p-3 rounded border border-gray-300 focus:outline-none focus:border-[#00df9a]"
                    value={form.name}
                    onChange={e => setForm({ ...form, name: e.target.value })}
                  />
                </div>
                <div className="flex-1 flex flex-col">
                  <label htmlFor="email" className="mb-1 font-semibold text-gray-700">
                    Email
                  </label>
                  <input
                    id="reply_to"
                    type="email"
                    name="reply_to"
                    required
                    className="p-3 rounded border border-gray-300 focus:outline-none focus:border-[#00df9a]"
                    value={form.email}
                    onChange={e => setForm({ ...form, email: e.target.value })}
                  />
                </div>
              </div>
              <div className="flex flex-col">
                <label htmlFor="message" className="mb-1 font-semibold text-gray-700">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows={5}
                  className="p-3 rounded border border-gray-300 focus:outline-none focus:border-[#00df9a]"
                  value={form.message}
                  onChange={e => setForm({ ...form, message: e.target.value })}
                />
              </div>
              <button
                type="submit"
                className="bg-[#00df9a] text-white font-bold py-3 px-8 rounded hover:bg-[#00b87c] transition-colors w-full md:w-auto"
              >
                Send Message
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default Contact;